export const getPosts = async (after) => {
    let url = "https://www.reddit.com/r/aww/hot.json";
    if (after) {
        url += `?after=${after}`;
    }

    const response = await fetch(url);
    const json = await response.json();

    const posts = json.data.children
        .map(child => child.data)
        .filter(postData => !postData.stickied)
        .map(postData => {
            return {
                id: postData.id,
                title: postData.title,
                ...extractMedia(postData)
            };
        })
        .filter(post => post.type === "image"); // TODO Remove

    return {
        posts,
        after: json.data.after
    };
}

export const getPostsById = async (postIds) => {

    if (!postIds.length) {
        return [];
    }

    let url = 'https://www.reddit.com/by_id/';
    for (let i = 0; i < postIds.length; i++) {
        url += 't3_' + postIds[i];
        if (i < postIds.length - 1) {
            url += ',';
        }
    }
    url += '.json';

    const response = await fetch(url);
    const json = await response.json();

    return json.data.children
        .map(child => child.data)
        .map(postData => {
            return {
                id: postData.id,
                title: postData.title,
                ...extractMedia(postData)
            };
        })
        .filter(post => post.media);
};

function extractMedia(obj) {
    const converters = [extractSecureMediaVideo, extractVideo, extractGifv, extractImage];
    for (const converter of converters) {
        try {
            return converter(obj);
        } catch (e) {
            // Catch so that the others converters are tried.
        }
    }

    return null;
}

function extractSecureMediaVideo(obj) {
    return {
        url: obj.crosspost_parent_list[0].secure_media.reddit_video.fallback_url,
        type: "video"
    };
}

function extractVideo(obj) {
    return {
        url: obj.media.reddit_video.fallback_url,
        type: "video"
    };
}

function extractGifv(obj) {
    return {
        url: obj.preview.reddit_video_preview.fallback_url,
        type: "gifv"
    };
}

function extractImage(obj) {
    const image = obj.preview.images[0];

    const media = [];
    const parser = new DOMParser();

    for (const resolution of image.resolutions) {
        media.push({
            url: parser.parseFromString(resolution.url, "text/html").documentElement.textContent,
            width: resolution.width,
            height: resolution.height
        });
    }

    media.push({
        url: parser.parseFromString(image.source.url, "text/html").documentElement.textContent,
        width: image.source.width,
        height: image.source.height
    });

    return {
        media,
        type: "image"
    };
}